import { render, staticRenderFns } from "./HotSpot.vue?vue&type=template&id=1004dfeb&scoped=true&"
import script from "./HotSpot.vue?vue&type=script&lang=js&"
export * from "./HotSpot.vue?vue&type=script&lang=js&"
import style0 from "./HotSpot.vue?vue&type=style&index=0&id=1004dfeb&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1004dfeb",
  null
  
)

export default component.exports